var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('list',{ref:"list",attrs:{"can-price":_vm.$permission.canPrice()}},[(_vm.$permission.canWrite())?_c('template',{slot:"toolbar-right"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":_vm.onAddPurchase}},[_vm._v("生成采购订单")])],1):_vm._e(),_c('template',{slot:"column"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }